module.exports = __webpack_public_path__ + "img/eurogamer.0350234c.png";